<template>
  <b-row
    class="multi-variable-select-one-preference-input d-flex justify-content-center mb-4"
  >
    <b-col
      :class="[{ 'col-12': forQuestionForm, 'col-5 phairify-border-grey ml-4 mt-4': !forQuestionForm }]"
      v-for="(v, index) in jobQuestion.jobQuestionVariables"
      :key="v.id + index + '_jq' + (forQuestionForm ? '_fm' : '')"
    >
      <b-form-group
        :label="v.input_label + ':'"
      >
        <b-form-radio-group
          :name="v.id + '_jq' + (forQuestionForm ? '_fm' : '')"
          class="text-left col v3_control_radio_group"
          :checked="v.jobProfileQuestionResponses[0].value"
          stacked
        >
          <b-form-radio
            v-for="(option, oIndex) in v.variableOptions"
            :value="option.id"
            :key="option.id + oIndex + '_jqo'"
            @change="(val) => onChangeHandler(v, val)"
          >
            {{ option.name }}
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import SubFormValidationMethodsMixin from '@/mixins/SubFormValidationMethodsMixin';

export default {
  name: 'MultiVariableSelectOnePreferenceInput',
  mixins: [validationMixin, SubFormValidationMethodsMixin],
  props: {
    jobQuestion: {
      required: true,
    },
    forQuestionForm: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    selected: {},
  },
  methods: {
    onChangeHandler: function (variable, value) {
      this.$emit('set-preference', variable.id, value);
      this.$v.selected.$touch();
    },
  },
};
</script>

<style lang="scss">
@import '../../../../sass/variables_mixins';
.multi-variable-select-one-preference-input {
  .custom-control {
    margin: 0.5rem 0;
    .custom-control-label {
      padding-left: 0.5rem;
    }
  }
}
</style>
